import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/earlyImage.svg'


const _withScopeId = n => (_pushScopeId("data-v-4841f28e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modalContent" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: ""
}, null, -1))
const _hoisted_5 = { class: "w-100 mt-3 pt-3" }
const _hoisted_6 = {
  class: "btn btn-primary w-100 mx-auto mb-3",
  href: "https://www.merlatabloommilano.com/",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_countdown = _resolveComponent("countdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_localized_text, {
          type: "h1",
          localizedKey: "app_Sei in anticipo!",
          text: "Sei in anticipo!",
          class: "mt-4 mb-3"
        }),
        _createVNode(_component_localized_text, {
          type: "h3",
          localizedKey: "app_Mancano ancora",
          text: "Mancano ancora"
        }),
        _createVNode(_component_countdown, { endDate: _ctx.startDate }, null, 8, ["endDate"]),
        _createVNode(_component_localized_text, {
          type: "p",
          localizedKey: "app_Intanto, informati sugli artisti degli IDays 2024 e su Merlata Bloom Milano, così aumenterai le probabilità di vincere!",
          text: "Intanto, informati sugli artisti degli IDays 2024 e su Merlata Bloom Milano, così aumenterai le probabilità di vincere!",
          class: "text mt-4"
        }),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", _hoisted_6, [
            _createVNode(_component_localized_text, {
              localizedKey: "app_Visita il sito",
              text: "Visita il sito"
            })
          ])
        ])
      ])
    ])
  ]))
}